<template>
  <div :class="b()">
    <slot />
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';

export default {
  name: 'MoreItem',
  bemNS: theme.bemNS,
  inject: ['applySize'],
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  mounted() {
    this.resizeOb = new ResizeObserver(([entry]) => this.onResize(entry.contentRect.width));
    this.resizeOb.observe(this.$el);
    this.onResize(this.$el.getBoundingClientRect().width);
  },
  beforeDestroy() {
    this.resizeOb.unobserve(this.$el);
    this.resizeOb.disconnect();
    this.resizeOb = null;
    this.applySize(this.id, null);
  },
  methods: {
    onResize(width) {
      this.applySize(this.id, width);
    }
  }
};
</script>

<style lang="scss">

</style>
